import React, {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";
import { Experiment, ExperimentState, ExperimentVariant } from "redmond";
import { fetchActiveExperiments } from "../api/v0/experiments/fetchExperiments";

// Active Experiments
export const CFAR = "c1-fintech-cfar";
export const CHFAR = "c1-fintech-chfar-v0";
export const REFUNDABLE_FARES = "c1-fintech-cfar-refundable-fares";
export const CFAR_SOCIAL = "c1-fintech-cfar-social";
export const DISRUPTION = "c1-fintech-disruption";
export const ANCILLARY_MARKETPLACE = "c1-fintech-ancillary-marketplace";
export const SIMILAR_FLIGHTS = "c1-fintech-similarflights";
export const SEAT_SELECTION = "c1-marketplace-seatselection";
export const FLIGHT_SHOP = "c1-foundations-flightshop";
export const MOBILE_PREDICTION = "c1-marketplace-mobileprediction";
export const CFAR_MULTI_CITY = "c1-fintech-cfar-multi-city";
export const TREES_MODAL_EXPERIMENT = "c1-marketplace-trees";
export const INTERNATIONAL_NGS_EXPERIMENT = "c1-marketplace-international-ngs";
export const TRAVEL_WALLET_OFFER_EXPERIMENT =
  "c1-marketplace-travel-wallet-offers";
export const CASH_VALUEPROP_EXPERIMENT = "c1-marketplace-cash-valueprop-merch";
export const TRAVEL_WALLET_CREDITS_EXPERIMENT =
  "c1-marketplace-travel-wallet-credits";
export const PRICE_MATCH_CREDITS_EXPERIMENT =
  "c1-marketplace-price-match-credits";

export const POST_BOOKING_OFFER_EXPERIMENT =
  "c1-fintech-disruption-air-postbookingoffer";
export const POST_BOOKING_OFFER_EXPERIMENT_REWARDS =
  "c1-fintech-disruption-air-postbookingoffer-rewards";
export const PRICE_DROP_CREDIT = "c1-fintech-price-drop-credit";
export const PRICE_PREDICTION_GRADIENT = "c1-fintech-price-prediction-gradient";
export const PRICE_WATCH_PUSH = "c1-fintech-price-watch-push";
export const PRICE_WATCH_PUSH_DEFAULT_OPT_IN =
  "c1-fintech-price-watch-push-default-optin";
export const PREFERRED_HOTEL_EXPERIMENT =
  "c1-marketplace-cot-preferred-hotel-merch";
export const LODGING_PROMOTIONS = "HotelPromotion";
export const HOTELS_HOMEPAGE_CROSS_SELL_EXPERIMENT =
  "c1-marketplace-homepage-hotel-cross-sell";
export const FLIGHT_LIST_OPTIMIZATION_V1_EXPERIMENT =
  "c1-marketplace-flight-list-optimization-v1";
export const VCN_ENABLEMENT = "c1-marketplace-vcn-enablement";
export const VOID_WINDOW_EXPERIMENT = "c1_marketplace_void_window";
export const PREMIER_COLLECTION_EXPERIMENT =
  "c1-marketplace-luxury-hotels-collection";
export const AIR_MULTICITY_EXPERIMENT = "b2b-agency-air-multicity";
export const AIR_CHATBOT_EXPERIMENT = "b2b-agency-air-pricing-chatbot";
export const CREDIT_OFFER_STACKING_V1 =
  "c1-marketplace-credit-offer-stacking-v1";
export const TRAVEL_CREDIT_HISTORY_EXPERIMENT =
  "c1-marketplace-credit-transaction-history";
export const RECENTLY_VIEWED_V2_FLIGHTS =
  "c1-marketplace-recently-viewed-v2-air";
export const ANNUAL_TRAVEL_CREDITS = "c1-marketplace-annual-travel-credits";
export const C1_AUTO_SELECT_CARD_AT_CHECKOUT =
  "c1-auto-select-card-at-checkout";
export const SEATS_UX_OPTIMIZATION = "c1-marketplace-seats-ux-optimization";
export const AIR_FARECLASS_FILTER_EXPERIMENT =
  "c1-marketplace-air-fareclass-filter";
export const CAP_ONE_DISRUPTION_OPT_IN = "Cap1DisruptionPushNotifOptin";
export const NON_FDA_CAP_ONE_DISRUPTION_OPT_IN =
  "NonFDACap1DisruptionPushNotifOptin";
export const FARE_DETAILS_MOBILE = "c1-marketplace-fare-details-mobile";
export const PASSPORT_ENHANCEMENT = "c1-marketplace-passport-enhancement";
export const TRAVEL_SALE = "c1-marketplace-travel-sale";
export const CFAR_ANCILLARY_COMERCH = "c1-fintech-cfar-model-v2";
export const AIR_CX_V3_1 = "c1-marketplace-air-cx-v3.1";
export const CUSTOMER_PROFILE_EXPERIMENT = "c1-marketplace-customer-profile";
export const CFAR_REMOVE_FRONTEND_ELIGIBILITY_CHECK =
  "c1-fintech-cfar-remove-frontend-eligibility-check";
export const CFAR_OFFER_SHOW_REFUND_COPY_EXPERIMENT =
  "c1-cfar-air-refund-amount";
export const CFAR_REFUND_COPY_CONTROL = "Control";
export const CFAR_REFUND_COPY_COMPARISON_CONTROL = "ComparisonControl";
export const CFAR_REFUND_COPY_Challenger1 = "RefundAmountCopy";
export const CFAR_REFUND_COPY_Challenger2 = "RefundAmountCopyAndCTA";
export const AMADEUS_FRONTER_EXPERIMENT =
  "ProvidersExperimentAmadeusFrontierBookability";
export const COT_PAYMENT_FLEX_SURVEY = "cot-payment-flex-survey";
export const FLIGHTS_TRAVEL_INSURANCE_SMOKE_TEST =
  "c1-flights-travel-insurance-smoke-test";
export const POST_BOOKING_CFAR_FARE_OPTIMIZATION_ENTRY_POINT =
  "c1-post-booking-cfar-fo-entry-point";

export const CFAR_REFUND_COPY_VARIANTS = [
  CFAR_REFUND_COPY_CONTROL,
  CFAR_REFUND_COPY_COMPARISON_CONTROL,
  CFAR_REFUND_COPY_Challenger1,
  CFAR_REFUND_COPY_Challenger2,
] as const;

export type CfarRefundCopyVariantType =
  | typeof CFAR_REFUND_COPY_CONTROL
  | typeof CFAR_REFUND_COPY_COMPARISON_CONTROL
  | typeof CFAR_REFUND_COPY_Challenger1
  | typeof CFAR_REFUND_COPY_Challenger2;

export const GLOBAL_MOBILE_NAV_EXPERIMENT = "c1-marketplace-global-mobile-nav";
export const CFAR_ENABLE_F9_NK_AIRLINE = "c1-fintech-cfar-enable-f9-nk-airline";
export const GOVERNMENT_SHUTDOWN_BANNER_EXPERIMENT =
  "c1-fintech-disruption-government-shutdown-banner";
export const FINTECH_CSAT = "c1-fintech-csat";
export const HOTEL_CROSS_SELL_V3_EXPERIMENT =
  "c1-marketplace-hotel-cross-sell-v3";
export const FLIGHT_CROSS_SELL_PREFETCH_EXPERIMENT =
  "c1-flight-cross-sell-prefetch";
export const HOTELS_TAXES_AND_FEES_EXPERIMENT =
  "c1-marketplace-HotelsCaliforniaBill537";
export const AIR_CX_V4 = "c1-marketplace-air-cx-v4";
export const PACKAGES_EXPERIMENT = "c1-marketplace-packages";
export const PACKAGES_FLIGHTS_ENTRY = "c1-marketplace-packages-flights-entry";
export const CACHE_HOTEL_TOKEN = "c1-marketplace-cache-hotel-token";
// VI TEAM experiments
export const THEBES_HACKER_FARES_IN_CAP1 = "ThebesHackerFaresInCap1";
export const THEBES_VIRTUAL_INTERLINING_IN_CAP1 =
  "ThebesVirtualInterliningInCap1";

export const CFAR_DISCOUNT = "c1-cfar-air-discount";

// variants for c1-cfar-air-discount
export const CFAR_DISCOUNT_CONTROL = "control";
export const CFAR_DISCOUNT_10_PERCENT = "10percentdiscount";
export const CFAR_DISCOUNT_25_PERCENT = "25percentdiscount";
export const CFAR_DISCOUNT_75_PERCENT = "75percentdiscount";
export const CFAR_DISCOUNT_100_PERCENT = "100percentdiscount";
export const CFAR_DISCOUNT_VARIANTS = [
  CFAR_DISCOUNT_CONTROL,
  CFAR_DISCOUNT_10_PERCENT,
  CFAR_DISCOUNT_25_PERCENT,
  CFAR_DISCOUNT_75_PERCENT,
  CFAR_DISCOUNT_100_PERCENT,
] as const;
export type CfarDiscountVariantType =
  | typeof CFAR_DISCOUNT_CONTROL
  | typeof CFAR_DISCOUNT_10_PERCENT
  | typeof CFAR_DISCOUNT_25_PERCENT
  | typeof CFAR_DISCOUNT_75_PERCENT
  | typeof CFAR_DISCOUNT_100_PERCENT;

export const VI_EXPERIMENT_CONTROL = "Control";
export const VI_EXPERIMENT_AVAILABLE = "Available";
export const VI_EXPERIMENT_VARIANTS = [
  VI_EXPERIMENT_CONTROL,
  VI_EXPERIMENT_AVAILABLE,
] as const;
export type VIVariantType =
  | typeof VI_EXPERIMENT_CONTROL
  | typeof VI_EXPERIMENT_AVAILABLE;

// variants for c1-agency-virtual-interlining-shop-banners
export const VI_SHOP_BANNERS_EXPERIMENT =
  "c1-agency-virtual-interlining-shop-banners";
export const VI_SHOP_BANNERS_CONTROL = "control";
export const VI_SHOP_BANNERS_NO_BANNER = "no-banner";
export const VI_SHOP_BANNERS_GRAY_BANNER = "gray-banner";
export const VI_SHOP_BANNERS_VARIANTS = [
  VI_SHOP_BANNERS_CONTROL,
  VI_SHOP_BANNERS_NO_BANNER,
  VI_SHOP_BANNERS_GRAY_BANNER,
] as const;

export const EXPENSE_MANAGEMENT_MODAL_EXP = "corp-cobt-em-modal";

// Default variants
export const CONTROL = "control";
export const AVAILABLE = "available";
export const DEFAULT_VARIANTS = [CONTROL, AVAILABLE] as const;
export type DefaultVariantType = typeof CONTROL | typeof AVAILABLE;

// Uppercase Default variants
export const UC_CONTROL = "Control";
export const UC_AVAILABLE = "Available";
export const UC_DEFAULT_VARIANTS = [UC_CONTROL, UC_AVAILABLE] as const;
export type UppercaseDefaultVariantType =
  | typeof UC_CONTROL
  | typeof UC_AVAILABLE;

// Variants for CAP_ONE_DISRUPTION_OPT_IN
export const CAP_ONE_DISRUPTION_OPT_IN_CONTROL = "control";
export const CAP_ONE_DISRUPTION_OPT_IN_COMPARISON_CONTROL =
  "comparison-control";
export const CAP_ONE_DISRUPTION_OPT_IN_SCREEN_WITH_PUSH_OPT_IN =
  "screen-with-push-opt-in";
export const CAP_ONE_DISRUPTION_OPT_IN_3_HOUR_THRESHOLD =
  "opt-in-3-hr-threshold";
export const CAP_ONE_DISRUPTION_OPT_IN_VARIANTS = [
  CAP_ONE_DISRUPTION_OPT_IN_CONTROL,
  CAP_ONE_DISRUPTION_OPT_IN_COMPARISON_CONTROL,
  CAP_ONE_DISRUPTION_OPT_IN_SCREEN_WITH_PUSH_OPT_IN,
  CAP_ONE_DISRUPTION_OPT_IN_3_HOUR_THRESHOLD,
] as const;

export const HTS_FDA_MARKETING = "c1-hts-fda-marketing";

export type CapOneDisruptionOptInVariantType =
  | typeof CAP_ONE_DISRUPTION_OPT_IN_CONTROL
  | typeof CAP_ONE_DISRUPTION_OPT_IN_COMPARISON_CONTROL
  | typeof CAP_ONE_DISRUPTION_OPT_IN_SCREEN_WITH_PUSH_OPT_IN
  | typeof CAP_ONE_DISRUPTION_OPT_IN_3_HOUR_THRESHOLD;

// Variants for ANCILLARY_MARKETPLACE
export const ANCILLARY_MARKETPLACE_CONTROL = "control";
export const ANCILLARY_MARKETPLACE_SINGLE_PAGE = "single-page";
export const ANCILLARY_MARKETPLACE_MULTI_PAGE = "multi-page";
export const ANCILLARY_MARKETPLACE_FLIGHT_BOOK = "flight-book";
export const ANCILLARY_MARKETPLACE_VARIANTS = [
  ANCILLARY_MARKETPLACE_CONTROL,
  ANCILLARY_MARKETPLACE_SINGLE_PAGE,
  ANCILLARY_MARKETPLACE_MULTI_PAGE,
  ANCILLARY_MARKETPLACE_FLIGHT_BOOK,
] as const;
export type AncillaryMarketplaceVariantType =
  | typeof ANCILLARY_MARKETPLACE_CONTROL
  | typeof ANCILLARY_MARKETPLACE_SINGLE_PAGE
  | typeof ANCILLARY_MARKETPLACE_MULTI_PAGE
  | typeof ANCILLARY_MARKETPLACE_FLIGHT_BOOK;

// Variants for CFAR_SOCIAL
// Note that we are using this experiment for social proofing in general now, rather than just CFAR.
export const CFAR_SOCIAL_CONTROL = "control";
export const CFAR_SOCIAL_SOCIAL_PROOF = "social-proof";
export const CFAR_SOCIAL_SOCIAL_PROOF_TESTIMONY = "social-proof-testimony";
export const CFAR_SOCIAL_SOCIAL_PROOF_TESTIMONY_CFAR_FDA =
  "social-proof-testimony-CFAR-FDA";
export const CFAR_SOCIAL_VARIANTS = [
  CFAR_SOCIAL_CONTROL,
  CFAR_SOCIAL_SOCIAL_PROOF,
  CFAR_SOCIAL_SOCIAL_PROOF_TESTIMONY,
  CFAR_SOCIAL_SOCIAL_PROOF_TESTIMONY_CFAR_FDA,
] as const;
export type CfarSocialVariantType =
  | typeof CFAR_SOCIAL_CONTROL
  | typeof CFAR_SOCIAL_SOCIAL_PROOF
  | typeof CFAR_SOCIAL_SOCIAL_PROOF_TESTIMONY
  | typeof CFAR_SOCIAL_SOCIAL_PROOF_TESTIMONY_CFAR_FDA;

// Variants for PRICE_PREDICTION_GRADIENT
export const PRICE_PREDICTION_GRADIENT_CONTROL = "control";
export const PRICE_PREDICTION_GRADIENT_V2 = "v2";
export const PRICE_PREDICTION_GRADIENT_VARIANTS = [
  PRICE_PREDICTION_GRADIENT_CONTROL,
  PRICE_PREDICTION_GRADIENT_V2,
] as const;
export type PricePredictionGradientVariantType =
  | typeof PRICE_PREDICTION_GRADIENT_CONTROL
  | typeof PRICE_PREDICTION_GRADIENT_V2;

// Variants for c1-marketplace-cash-valueprop-merch
export const CASH_VALUEPROP_A = "cash-valueprop-a";
export const CASH_VALUEPROP_B = "cash-valueprop-b";
export const CASH_VALUEPROP_C = "cash-valueprop-c";
export const CASH_VALUEPROP_VARIANTS = [
  CONTROL,
  CASH_VALUEPROP_A,
  CASH_VALUEPROP_B,
  CASH_VALUEPROP_C,
] as const;
export type CashValuePropVariantType =
  | typeof CONTROL
  | typeof CASH_VALUEPROP_A
  | typeof CASH_VALUEPROP_B
  | typeof CASH_VALUEPROP_C;

// Variants for cot-payment-flex-survey
export const PAY_FLEX_SURVEY_VARIANTS = [
  CONTROL,
  "apr_with_rewards",
  "apr_no_rewards",
  "fee_with_rewards",
  "fee_no_rewards",
] as const;

// Variants for c1-marketplace-cot-preferred-hotel-merch
export const PREFERRED_HOTELS_V1 = "v1-special-rates";
export const PREFERRED_HOTELS_VARIANT = [CONTROL, PREFERRED_HOTELS_V1] as const;
export type PreferredHotelsPropVariantType =
  | typeof CONTROL
  | typeof PREFERRED_HOTELS_V1;

// Variants for HotelPromotion
export const LODGING_PROMOTIONS_AVAILABLE = "Available";
export const LODGING_PROMOTIONS_VARIANTS = [
  CONTROL,
  LODGING_PROMOTIONS_AVAILABLE,
] as const;
export type LodgingPromotionsPropVariantType =
  | typeof CONTROL
  | typeof LODGING_PROMOTIONS_AVAILABLE;

export const AIR_OFFER_REDESIGN = "c1-fintech-disruption-air-offerredesign";
// variants for c1-fintech-disruption-air-offerredesign
export const AIR_OFFER_REDESIGN_CONTROL = "control";
export const AIR_OFFER_REDESIGN_COMPARISON_CONTROL = "comparison-control";
export const AIR_OFFER_REDESIGN_TABLE_CONCEPT = "table-concept";
export const AIR_OFFER_REDESIGN_VARIANTS = [
  AIR_OFFER_REDESIGN_CONTROL,
  AIR_OFFER_REDESIGN_COMPARISON_CONTROL,
  AIR_OFFER_REDESIGN_TABLE_CONCEPT,
] as const;
export type AirOfferRedesignVariantType =
  | typeof AIR_OFFER_REDESIGN_CONTROL
  | typeof AIR_OFFER_REDESIGN_COMPARISON_CONTROL
  | typeof AIR_OFFER_REDESIGN_TABLE_CONCEPT;

// Variants for c1-marketplace-travel-sale
export const TRAVEL_SALE_LEAD_UP = "lead-up";
export const TRAVEL_SALE_ACTIVE = "active";
export const TRAVEL_SALE_VARIANTS = [
  CONTROL,
  TRAVEL_SALE_LEAD_UP,
  TRAVEL_SALE_ACTIVE,
] as const;
export type TravelSalePropVariantType =
  | typeof CONTROL
  | typeof TRAVEL_SALE_LEAD_UP
  | typeof TRAVEL_SALE_ACTIVE;

// variants for CFAR CoMerch
export const CFAR_COMERCH_CONTROL = "Control";
export const CFAR_COMERCH_90_70_SHELF_ADV_GBV = "comerch90and70shelfadvgbv";
export const CFAR_COMERCH_90_70_RANDOM = "comerch90and70random";
export const CFAR_COMERCH_90_80_SHELF_ADV_GBV = "comerch90and80shelfadvgbv";
export const CFAR_COMERCH_90_80_RANDOM = "comerch90and80random";
export const CFAR_COMERCH_VARIANTS = [
  CFAR_COMERCH_CONTROL,
  CFAR_COMERCH_90_70_SHELF_ADV_GBV,
  CFAR_COMERCH_90_70_RANDOM,
  CFAR_COMERCH_90_80_SHELF_ADV_GBV,
  CFAR_COMERCH_90_80_RANDOM,
] as const;
export type CFARCoMerchVariantType =
  | typeof CFAR_COMERCH_CONTROL
  | typeof CFAR_COMERCH_90_70_SHELF_ADV_GBV
  | typeof CFAR_COMERCH_90_70_RANDOM
  | typeof CFAR_COMERCH_90_80_SHELF_ADV_GBV
  | typeof CFAR_COMERCH_90_80_RANDOM;

// Variants for c1-fintech-disruption-air-postbookingoffer
export const POST_BOOKING_OFFER_3 = "available-3";
export const POST_BOOKING_OFFER_7 = "available-7";
export const POST_BOOKING_OFFER_14 = "available-14";
export const POST_BOOKING_OFFER_VARIANTS = [
  POST_BOOKING_OFFER_3,
  POST_BOOKING_OFFER_7,
  POST_BOOKING_OFFER_14,
  CONTROL,
  AVAILABLE,
] as const;

export type PostBookingOfferVariantType =
  | typeof CONTROL
  | typeof AVAILABLE
  | typeof POST_BOOKING_OFFER_3
  | typeof POST_BOOKING_OFFER_7
  | typeof POST_BOOKING_OFFER_14;

// Variants for c1-fintech-disruption-air-postbookingoffer-rewards
export const POST_BOOKING_OFFER_REWARDS_MERCH = "available-with-merch";
export const POST_BOOKING_OFFER_REWARDS_VARIANTS = [
  POST_BOOKING_OFFER_REWARDS_MERCH,
  CONTROL,
  AVAILABLE,
] as const;

export type PostBookingOfferRewardsVariantType =
  | typeof CONTROL
  | typeof AVAILABLE
  | typeof POST_BOOKING_OFFER_REWARDS_MERCH;

// Variants c1-marketplace-air-cx-v3.1
export const AIR_CX_V3_1_VARIANT_1 = "variant-1";
export const AIR_CX_V3_1_VARIANT_2 = "variant-2";
export const AIR_CX_V3_1_VARIANTS = [
  CONTROL,
  AIR_CX_V3_1_VARIANT_1,
  AIR_CX_V3_1_VARIANT_2,
] as const;
export type AirCXV3VariantType =
  | typeof CONTROL
  | typeof AIR_CX_V3_1_VARIANT_1
  | typeof AIR_CX_V3_1_VARIANT_2;

// Variants for c1-marketplace-customer-profile
export const DEFAULT_OFF = "default-off";
export const DEFAULT_ON = "default-on";
export const CUSTOMER_PROFILE_VARIANTS = [
  CONTROL,
  DEFAULT_OFF,
  DEFAULT_ON,
] as const;
export type CustomerProfileVariantType =
  | typeof CONTROL
  | typeof DEFAULT_OFF
  | typeof DEFAULT_ON;

// Variants c1-marketplace-hotel-cross-sell-v3
export const HOTEL_CROSS_SELL_V3_VARIANT_1 = "dollar-offer";
export const HOTEL_CROSS_SELL_V3_VARIANT_2 = "percentage-offer";
export const HOTEL_CROSS_SELL_V3_VARIANTS = [
  CONTROL,
  HOTEL_CROSS_SELL_V3_VARIANT_1,
  HOTEL_CROSS_SELL_V3_VARIANT_2,
] as const;
export type HotelCrossSellV3VariantType =
  | typeof CONTROL
  | typeof HOTEL_CROSS_SELL_V3_VARIANT_1
  | typeof HOTEL_CROSS_SELL_V3_VARIANT_2;
// Corporate Travel
export const CORP_HIDE_PRICE_DROP_EXPERIMENT =
  "corp-hide-price-drop-protection";
export const CORP_EMBEDDED_TRAVELER_FORM_EXPERIMENT =
  "corp-embedded-traveler-form";
export const CHECKOUT_REWARDS_EARN_BANNER_EXPERIMENT =
  "corp-checkout-rewards-earn-banner";
export const REWARDS_EARN_BANNER_VARIANT_FLIGHTS = "flights-earn";
export const CORP_FLIGHT_DISCOUNT_RATE_UI = "corp-flight-discount-rate-ui";
export const CORP_DISCOUNTED_RATE = "discounted-rate";
export const CORP_CORPORATE_RATE = "corporate-rate";
export const CORP_FLIGHT_DISCOUNT_RATE_UI_VARIANTS = [
  CONTROL,
  AVAILABLE,
  CORP_DISCOUNTED_RATE,
  CORP_CORPORATE_RATE,
] as const;

// Variants for c1-marketplace-HotelsCaliforniaBill537
export const LEAST_DISRUPTION = "least-disruption";
export const BEST_COMPLIANCE = "best-compliance";
export const HOTELS_TAXES_AND_FEES_VARIANTS = [
  CONTROL,
  LEAST_DISRUPTION,
  BEST_COMPLIANCE,
] as const;
export type HotelsTaxesAndFeesVariantType =
  | typeof CONTROL
  | typeof LEAST_DISRUPTION
  | typeof BEST_COMPLIANCE;

const defaultInitializer = (): ExperimentState => ({
  experiments: [],
  trackingProperties: undefined,
});

// Variants for c1-marketplace-packages
export const SELF_FUNDED = "self-funded";
export const NOT_SELF_FUNDED = "not-self-funded";
export const PACKAGES_EXPERIMENT_VARIANTS = [
  CONTROL,
  SELF_FUNDED,
  NOT_SELF_FUNDED,
] as const;
export type PackagesExperimentVariantType =
  | typeof CONTROL
  | typeof SELF_FUNDED
  | typeof NOT_SELF_FUNDED;

// variants for c1-fintech-chfar-v0
export const PRODUCTION = "production";
export const DECLINE_ALL = "declineAll";
export const CHFAR_VARIANTS = [
  CONTROL,
  AVAILABLE,
  PRODUCTION,
  DECLINE_ALL,
] as const;
export type ChfarVariantsType =
  | typeof CONTROL
  | typeof AVAILABLE
  | typeof PRODUCTION
  | typeof DECLINE_ALL;

export const XMOD_V1_EXPERIMENT = "c1-marketplace-xmod-v1";

export const CFAR_REFUNDABLE_FARES_HTS_MERCHANDISING =
  "c1-flex-refundable-fares-hts-content";

export const CORE_FLIGHTS = "c1-replatform-flights-funnel";
export const CORE_FLIGHTS_COTA = "c1-replatform-flights-funnel-cota";
export const TRAVEL_APP_GTM_EXPERIMENT = "c1-portex-app-gtm";

export const POST_BOOKING_CFAR_EXPERIMENT = "c1-post-booking-cfar";
export const POST_BOOKING_CFAR_VARIANT_A = "variant-a";
export const POST_BOOKING_CFAR_VARIANTS = [
  CONTROL,
  POST_BOOKING_CFAR_VARIANT_A,
] as const;
export type PostBookingCfarVariantType =
  | typeof CONTROL
  | typeof POST_BOOKING_CFAR_VARIANT_A;

// Variants for c1-flights-travel-insurance-smoke-test
export const AVAILABLE_WITH_FINTECH = "available-with-fintech";
export const FLIGHTS_TRAVEL_INSURANCE_SMOKE_TEST_VARIANTS = [
  CONTROL,
  AVAILABLE,
  AVAILABLE_WITH_FINTECH,
] as const;
export type FlightsTravelInsuranceSmokeTestVariantType =
  | typeof CONTROL
  | typeof AVAILABLE
  | typeof AVAILABLE_WITH_FINTECH;

export const ExperimentsContext = createContext<ExperimentState | undefined>(
  undefined,
);

// readonly (together with const restriction below) ensures typeof supportedVariants[number]
// can be recognized by transpiler as an array of constants
// [string, ...string[]] ensures array is not empty.
export function getExperimentVariantCustomVariants<
  T extends readonly [string, ...string[]],
>(
  experiments: Array<Experiment>,
  experimentId: string,
  // List of supported variants. If the variant retreived is not recognized by the code, the code will fall back to the first variant.
  // Note the input list needs to be declared as const e.g. const DEFAULT_VARIANTS = [CONTROL, AVAILABLE] as const;
  supportedVariants: T,
): (typeof supportedVariants)[number] {
  const experiment = experiments?.find((exp) => exp.id === experimentId);
  if (experiment) {
    if (supportedVariants.includes(experiment.variant)) {
      return experiment.variant;
    }
    return supportedVariants[0];
  }
  return supportedVariants[0];
}

export function getExperimentVariant(
  experiments: Array<Experiment>,
  experimentId: string,
): DefaultVariantType {
  return getExperimentVariantCustomVariants(
    experiments,
    experimentId,
    DEFAULT_VARIANTS,
  );
}

export function useExperiments(): ExperimentState {
  const ctx = useContext(ExperimentsContext);
  if (!ctx) throw new Error(`must be used within a ExperimentsProvider`);
  return ctx;
}

export function useExperiment(
  experimentId: string,
  target: string = ExperimentVariant.AVAILABLE,
) {
  const { experiments } = useExperiments();
  if (!experiments) throw new Error("No experiments found in Context");
  const expVariant = getExperimentVariant(experiments, experimentId);

  return expVariant === target;
}

export function addTrackingProperties(
  trackingProperties: Map<string, string> | undefined,
  properties?: any,
): unknown {
  if (!properties) {
    properties = {};
  }
  if (trackingProperties) {
    properties.experiments = Object.keys(trackingProperties).map(
      (ex) => `${ex}_${trackingProperties![ex]}`,
    );
  }
  return properties;
}

const ExperimentsProvider: FC<
  { initState?: ExperimentState } & PropsWithChildren
> = ({ initState = defaultInitializer(), children }) => {
  // TODO: use tracking reducers
  const [state, setState] = useState(initState);

  useEffect(() => {
    if (!initState?.experiments.length) {
      const fetchExperiments = async () => {
        await fetchActiveExperiments().then((result) => {
          setState(result as ExperimentState);
        });
      };
      fetchExperiments();
    }
  }, []);

  return (
    <ExperimentsContext.Provider value={state}>
      {children}
    </ExperimentsContext.Provider>
  );
};

export default ExperimentsProvider;
